import { LocalizedString, PriceInCurrency } from "../general/models";

export interface OrdersTotalPriceForCurrencyId {
  averageOrderPrice: PriceInCurrency;
  ordersAmount: number;
  totalOrdersPrice: PriceInCurrency;
}

export interface MenuCategoryRevenueStats {
  firstOrderCreatedAt: Date;
  lastOrderCreatedAt: Date;
  menuCategoryId: number;
  revenue: PriceInCurrency;
  totalMenuItemsCount: number;
  totalOrdersCount: number;
  menuCategoryName: LocalizedString;
}

export interface MenuItemRevenueStats {
  firstOrderCreatedAt: Date;
  lastOrderCreatedAt: Date;
  menuCategoryId: number;
  menuItemId: number;
  revenue: PriceInCurrency;
  totalOrdersCount: number;
  menuItemName: LocalizedString;
}

export enum AggregationPeriod {
  //minutes = "Minutes",
  //hours = "Hours",
  days = "Days",
  weeks = "Weeks",
  month = "Months",
}

export enum Period {
  custom_period,
  yesterday,
  today,
  beginning_week,
  previous_week,
  beginning_month,
  previous_month,
  beginning_quarter,
  previous_quarter,
  beginning_year,
  previous_year,
}

export enum Title {
    revenue = "Выручка",
    ordersAmount = "Заказы",
    averageCheck = "Средний чек"
}

export interface AggregationTimeInterval {
  amount: number;
  period: AggregationPeriod;
}

export enum StatsPeriodDataType {
  ordersAmount = "OrdersAmount",
  revenueAmount = "RevenueAmount",
  averageCheck = "AverageCheck",
}

export interface PeriodStats {
  currencyId: string | null;
  fromDate: Date;
  toDate: Date;
  total: number;
}

export interface DataForGraph {
  time: string;
  total: number | string;
}
